(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const contactStatus = document.querySelector('#ContactForm [data-contact-status]');
  if (contactStatus instanceof HTMLElement) {
    requestAnimationFrame(() => contactStatus.focus());
  }

  const messageField = document.querySelector('#ContactForm-body');
  const messageCount = document.querySelector('[data-message-count]');
  if (messageField instanceof HTMLTextAreaElement && messageCount instanceof HTMLElement) {
    const updateMessageCount = () => {
      messageCount.textContent = String(messageField.value.length);
    };
    updateMessageCount();
    messageField.addEventListener('input', updateMessageCount);
  }

  const enquirySelect = document.querySelector('[data-enquiry-select]');
  const languageSelect = document.querySelector('[data-language-select]');
  const formatSelect = document.querySelector('[data-format-select]');
  const lessonFields = document.querySelector('[data-lesson-fields]');
  const routeConfirmation = document.querySelector('[data-route-confirmation]');
  if (enquirySelect instanceof HTMLSelectElement) {
    const enquiryRoutes = {
      lessons: { enquiry: 'Live lessons', notice: 'lessonsMessage' },
      tutoring: { enquiry: 'Live lessons', notice: 'lessonsMessage' },
      group: { enquiry: 'Live lessons', language: 'Welsh', format: 'Group', notice: 'welshMessage' },
      english: { enquiry: 'Live lessons', language: 'English', format: 'One-to-one', notice: 'englishMessage' },
      english_group: { enquiry: 'Live lessons', language: 'English', format: 'Group', notice: 'englishMessage' },
      welsh: { enquiry: 'Live lessons', language: 'Welsh', notice: 'welshMessage' },
      english_help: { enquiry: 'Live lessons', language: 'English', notice: 'englishMessage' },
      one_to_one: { enquiry: 'Live lessons', format: 'One-to-one', notice: 'oneToOneMessage' },
      group_any: { enquiry: 'Live lessons', format: 'Group', notice: 'groupMessage' },
      course: { enquiry: 'Welsh Words online course' },
      help: { enquiry: 'Help choosing a learning route' },
      translation: { enquiry: 'Business translation' },
      voice_acting: { enquiry: 'Voice acting' },
      general: { enquiry: 'General question' }
    };
    const updateLessonFields = () => {
      const showLessonFields = enquirySelect.value === 'Live lessons';
      if (lessonFields instanceof HTMLElement) {
        lessonFields.hidden = !showLessonFields;
        lessonFields.querySelectorAll('select').forEach((select) => {
          select.disabled = !showLessonFields;
        });
      }
    };
    const enquiryRoute = new URLSearchParams(window.location.search).get('enquiry');
    if (enquiryRoute && enquiryRoutes[enquiryRoute]) {
      const route = enquiryRoutes[enquiryRoute];
      enquirySelect.value = route.enquiry;
      if (languageSelect instanceof HTMLSelectElement && route.language) {
        languageSelect.value = route.language;
      }
      if (formatSelect instanceof HTMLSelectElement && route.format) {
        formatSelect.value = route.format;
      }
      if (routeConfirmation instanceof HTMLElement && route.notice) {
        routeConfirmation.textContent = routeConfirmation.dataset[route.notice] || '';
        routeConfirmation.hidden = routeConfirmation.textContent === '';
      }
    }
    updateLessonFields();
    enquirySelect.addEventListener('change', () => {
      updateLessonFields();
      if (routeConfirmation instanceof HTMLElement) routeConfirmation.hidden = true;
    });
    [languageSelect, formatSelect].forEach((select) => {
      select?.addEventListener('change', () => {
        if (routeConfirmation instanceof HTMLElement) routeConfirmation.hidden = true;
      });
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'ContactForm') return;
    const trap = form.querySelector('[data-contact-trap]');
    if (trap && trap.value.trim() !== '') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const prepareSubmitFeedback = (root = document) => {
    root.querySelectorAll('[data-submit-feedback]').forEach((form) => {
      if (form.dataset.feedbackReady === 'true') return;
      form.dataset.feedbackReady = 'true';
      const initialButton = form.querySelector('[data-submit-button]');
      const initialLabel = initialButton?.querySelector('[data-submit-label]');
      if (initialButton) initialButton.dataset.originalAriaLabel = initialButton.getAttribute('aria-label') || '';
      if (initialLabel) initialLabel.dataset.originalLabel = initialLabel.textContent;

      form.addEventListener('submit', () => {
        const button = form.querySelector('[data-submit-button]');
        if (!button) return;
        const label = button.querySelector('[data-submit-label]');
        const icon = button.querySelector('[data-submit-icon]');
        const spinner = button.querySelector('.loading__spinner');
        const loadingLabel = button.dataset.loadingLabel;

        form.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        if (loadingLabel) button.setAttribute('aria-label', loadingLabel);
        if (label && loadingLabel) label.textContent = loadingLabel;
        if (icon) icon.hidden = true;
        if (spinner) spinner.classList.remove('hidden');
      });
    });
  };

  const resetSubmitFeedback = () => {
    document.querySelectorAll('[data-submit-feedback]').forEach((form) => {
      const button = form.querySelector('[data-submit-button]');
      if (!button) return;
      const label = button.querySelector('[data-submit-label]');
      const icon = button.querySelector('[data-submit-icon]');
      const spinner = button.querySelector('.loading__spinner');
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      if (button.dataset.originalAriaLabel) {
        button.setAttribute('aria-label', button.dataset.originalAriaLabel);
      } else {
        button.removeAttribute('aria-label');
      }
      if (label?.dataset.originalLabel) label.textContent = label.dataset.originalLabel;
      if (icon) icon.hidden = false;
      if (spinner) spinner.classList.add('hidden');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareSubmitFeedback(), { once: true });
  } else {
    prepareSubmitFeedback();
  }

  document.addEventListener('shopify:section:load', (event) => prepareSubmitFeedback(event.target));
  window.addEventListener('pageshow', resetSubmitFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const initialiseArticleNavigation = () => {
    const article = document.querySelector('.article-template');
    const content = article?.querySelector('.article-template__content');
    const contents = article?.querySelector('[data-article-contents]');
    const contentsList = article?.querySelector('[data-article-contents-list]');

    if (!article || !content) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());

    if (contents && contentsList && headings.length >= 3) {
      const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
      const assignedHeadingIds = new Set();

      headings.forEach((heading, index) => {
        if (!heading.id || assignedHeadingIds.has(heading.id)) {
          let headingId = `article-section-${index + 1}`;
          let duplicateNumber = 2;
          while (usedIds.has(headingId)) {
            headingId = `article-section-${index + 1}-${duplicateNumber}`;
            duplicateNumber += 1;
          }
          heading.id = headingId;
          usedIds.add(headingId);
        }
        assignedHeadingIds.add(heading.id);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') item.classList.add('article-template__contents-subitem');
        item.append(link);
        contentsList.append(item);
      });

      contents.hidden = false;
      if (window.matchMedia('(min-width: 750px)').matches) contents.open = true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseArticleNavigation, { once: true });
  } else {
    initialiseArticleNavigation();
  }

  const enhanceArticleContent = () => {
    document.querySelectorAll('.article-template__content').forEach((content) => {
      content.querySelectorAll('h2, h3, h4, h5, h6, p').forEach((element) => {
        const text = element.textContent.replace(/\u00a0/g, ' ').trim();
        const hasMedia = element.querySelector('img, video, iframe, audio, svg, table, a');
        if (text === '' && !hasMedia) element.hidden = true;
      });

      content.querySelectorAll('img').forEach((image) => {
        if (!image.hasAttribute('loading')) image.loading = 'lazy';
        if (!image.hasAttribute('decoding')) image.decoding = 'async';
      });

      content.querySelectorAll('iframe').forEach((frame) => {
        if (!frame.hasAttribute('loading')) frame.loading = 'lazy';
      });

      content.querySelectorAll('a').forEach((link) => {
        if (link.textContent.replace(/\u00a0/g, ' ').trim().toLowerCase() === 'here') {
          link.textContent = 'read the related Welsh Words article';
        }
        if (link.target === '_blank') {
          link.rel = 'noopener noreferrer';
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceArticleContent, { once: true });
  } else {
    enhanceArticleContent();
  }

  document.addEventListener('shopify:section:load', enhanceArticleContent);

  const initialiseCommentCounter = () => {
    const commentForm = document.querySelector('#CommentForm');
    const commentField = document.querySelector('#CommentForm-body');
    const commentCount = document.querySelector('[data-comment-count]');
    if (!(commentForm instanceof HTMLFormElement)) return;

    if (commentForm.dataset.commentSecurityInitialised !== 'true') {
      const commentTrap = commentForm.querySelector('[data-comment-trap]');
      commentForm.addEventListener('submit', (event) => {
        if (!(commentTrap instanceof HTMLInputElement) || commentTrap.value.trim() === '') return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      commentForm.dataset.commentSecurityInitialised = 'true';
    }

    if (!(commentField instanceof HTMLTextAreaElement) || !(commentCount instanceof HTMLElement)) return;
    if (commentField.dataset.counterInitialised === 'true') return;

    const updateCommentCount = () => {
      commentCount.textContent = String(commentField.value.length);
    };
    updateCommentCount();
    commentField.addEventListener('input', updateCommentCount);
    commentField.dataset.counterInitialised = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCommentCounter, { once: true });
  } else {
    initialiseCommentCounter();
  }

  document.addEventListener('shopify:section:load', initialiseCommentCounter);

  } catch(e) { console.error(e); }
})();
})();
